/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Modal,
} from 'react-bootstrap';
import { Editor, EditorState } from 'draft-js';
import 'draft-js/dist/Draft.css';
import RichButton from 'loracoms/RichButton';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  show: React.PropTypes.bool.isRequired,
  onHide: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class ParserAddModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      show: props.show,
      errors: ErrorSet.createEmpty().add('FE_EMPTY', 'name'),
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers.add');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeDesc = this.handleChangeDesc.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { show } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    const { appId } = this.props;
    const { errors, name, editorState } = this.state;

    if (!errors.isEmpty()) {
      return;
    }

    this.setState({ addStatus: 'pending' });

    const desc = editorState.getCurrentContent().getPlainText();
    callAPI({
      endpoint: '/lora/parsers',
      method: 'POST',
      body: {
        type: 'parser',
        name,
        desc,
        appid: appId,
        parser: {
          script: '',
        },
      },
    }).then((data) => {
      this.setState({
        addStatus: 'success',
        parserId: data.id,
      });
    }).catch(() => {
      this.setState({
        addStatus: 'failure',
      });
    });
  }

  handleChangeName(e) {
    const name = e.target.value.trim();
    const { errors } = this.state;
    if (name === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name'), name });
    } else {
      this.setState({ errors: errors.remove('name'), name });
    }
  }

  handleChangeDesc(editorState) {
    this.setState({ editorState });
  }

  render() {
    const { onHide, pushState, appId } = this.props;
    const {
      editorState,
      show = false,
      name = '',
      submitted = false,
      errors,
      addStatus = '',
      parserId = '',
    } = this.state;

    return (
      <Modal bsClass="aisz-modal-light" show={show} onHide={onHide}>
        <Modal.Header closeButton>
          {this.intlMsg.msg('modalheader')}
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit} horizontal>
            <FormGroup validationState={submitted && errors.has('name') ? 'error' : undefined}>
              <Col md={3}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('name')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  className="aisz-form-control"
                  value={name}
                  onChange={this.handleChangeName}
                />
                <ControlTips
                  show={submitted && errors.has('name')}
                  message={this.intlMsg.errorMsg(errors.get('name'))}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={3}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('desc')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Editor
                  editorState={editorState}
                  onChange={this.handleChangeDesc}
                  blockStyleFn={() => styles.desc}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col mdOffset={3} md={6}>
                <div className={styles.submit}>
                  <RichButton
                    status={addStatus}
                    states={[{
                      status: 'default',
                      style: 'primary',
                      label: (
                        <span>
                          <span className="halflings halflings-plus" />
                          {' '}{this.intlMsg.msg('submit')}
                        </span>
                      ),
                      type: 'submit',
                    }, {
                      status: 'pending',
                      style: 'info',
                      label: (
                        <span>
                          <i className="fa fa-spinner fa-spin" />
                          {' '}{this.intlMsg.msg('submitting')}
                        </span>
                      ),
                    }, {
                      status: 'success',
                      style: 'success',
                      label: (
                        <span>
                          <span className="halflings halflings-tick" />
                          {' '}{this.intlMsg.msg('submitsucc')}
                        </span>
                      ),
                      timer: () => pushState(`/application/${appId}/parse/${parserId}`),
                      delay: 500,
                    }, {
                      status: 'failure',
                      style: 'danger',
                      label: (
                        <span>
                          <span className="halflings halflings-warning-sign" />
                          {' '}{this.intlMsg.msg('submitfail')}
                        </span>
                      ),
                      timer: () => this.setState({ addStatus: '' }),
                      delay: 500,
                    }]}
                  />
                </div>
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

ParserAddModal.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(ParserAddModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserAddModal/index.jsx